import { CountryDialCode } from "../data/CountryDialCode"
import { CountryOptions } from "../data/CountryOptions"

export const formatPhone = (phone, country) => {
    let countryCode = country?.length === 3 ? (CountryOptions?.find(c => c.CodePrimus === country)?.Code || 'US') : country
    if(phone) {
        return CountryDialCode?.find(countryOne => countryOne.code === countryCode)?.dial_code+phone?.replace(CountryDialCode.find(countryOne => countryOne.code === countryCode)?.dial_code, '').replace('(','').replace(')','').replace('-','').replace(/\s+/g, '')
    } 
}